"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var BodySection_1 = require("./BodySection");
var Body = /** @class */ (function (_super) {
    tslib_1.__extends(Body, _super);
    function Body() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // used to exclude scrollbar width from body width calculations
        _this.clientWidth = 0;
        // used to exclude scrollbar height from body height calculations
        _this.clientHeight = 0;
        _this.scrollLeft = 0;
        _this.scrollTop = 0;
        _this.scrollable = null;
        _this.handleScrollableRefUpdated = function (s) {
            _this.scrollable = s;
            _this.updateClientWidthAndHeight();
            if (_this.props.onIScrollableRefUpdate) {
                _this.props.onIScrollableRefUpdate(s);
            }
        };
        _this.getScrollPosition = function () {
            if (!_this.scrollable) {
                return { scrollLeft: _this.scrollLeft, scrollTop: _this.scrollTop };
            }
            return _this.scrollable.getScrollPosition();
        };
        _this.onScroll = function (left, top) {
            _this.scrollLeft = left;
            _this.scrollTop = top;
            _this.props.onBodyScroll(left, top);
        };
        return _this;
    }
    Body.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.rememberLastScrollPos) {
            if (!this.isScrollTopPosValidForNextProps(nextProps)) {
                this.scrollToTop();
            }
        }
    };
    Body.prototype.componentDidUpdate = function () {
        this.updateClientWidthAndHeight();
        var scrollPos = this.getScrollPosition();
        if (this.scrollLeft !== scrollPos.scrollLeft || this.scrollTop !== scrollPos.scrollTop ||
            !this.isScrollTopPosValidForPageIndexes(scrollPos.scrollTop, this.props.pageIndexes)) {
            this.onScroll(scrollPos.scrollLeft, scrollPos.scrollTop);
        }
    };
    Body.prototype.updateClientWidthAndHeight = function () {
        if (!this.scrollable) {
            return;
        }
        var scrollNode = this.getScrollNode();
        if (scrollNode) {
            this.clientHeight = scrollNode.clientHeight;
            this.clientWidth = scrollNode.clientWidth;
        }
    };
    Body.prototype.getScrollNode = function () {
        if (!this.scrollable) {
            return null;
        }
        return this.scrollable.getScrollContainer();
    };
    Body.prototype.render = function () {
        var rows = this.props.rows;
        var scrollComponentProps = {
            marginTop: this.props.headerHeight,
            rootCssClass: 'tb-react-dg-body',
            scrollingRootId: this.props.scrollingRootId,
            onScroll: this.onScroll,
            onRefUpdated: this.handleScrollableRefUpdated
        };
        // tslint:disable-next-line:no-any
        var sections;
        var sectionsStyle;
        var actualTotalColumnWidth = this.props.totalColumnWidth + (this.props.leftMargin || 0);
        if (!rows.length) {
            sections = this.props.emptyChild;
            sectionsStyle = {
                width: (actualTotalColumnWidth > this.clientWidth) ? actualTotalColumnWidth : '100%',
                height: '100%'
            };
        }
        else {
            sections = this.renderSections();
            var topSpacer = this.props.pageIndexes.startRowIdx * this.props.rowOuterHeight;
            sectionsStyle = {
                paddingTop: topSpacer,
                paddingLeft: this.props.leftSpacer,
                height: rows.length * this.props.rowOuterHeight - topSpacer,
                width: (actualTotalColumnWidth > this.clientWidth) ? (actualTotalColumnWidth - this.props.leftSpacer) : '100%'
            };
        }
        return React.createElement(this.props.scrollComponent, scrollComponentProps, (React.createElement("div", { style: sectionsStyle }, sections)));
    };
    Body.prototype.onRowStoreChanged = function () {
        // e.g. after filtering to an empty list. Skip scrollToTop; re-init.
        if (!this.props.rememberLastScrollPos) {
            this.scrollToTop();
        }
    };
    Body.prototype.scrollToTop = function () {
        var _this = this;
        if (!this.scrollable) {
            return;
        }
        window.setTimeout(function () {
            if (!!_this.scrollable) {
                _this.scrollable.setScrollPosition(null, 0);
            }
        });
    };
    // tslint:disable-next-line:no-any
    Body.prototype.renderSections = function () {
        var pageIndexes = this.props.pageIndexes;
        // tslint:disable-next-line:no-any
        var sections = [];
        for (var sectionRowStartIdx = pageIndexes.startRowIdx; sectionRowStartIdx <= pageIndexes.endRowIdx; sectionRowStartIdx += this.props.sectionRows) {
            sections.push(BodySection_1.BodySection.element({
                key: Math.floor(sectionRowStartIdx / this.props.sectionRows),
                cols: this.props.cols,
                colStartIdx: pageIndexes.startColIdx,
                colEndIdx: Math.min(pageIndexes.endColIdx, this.props.cols.length - 1),
                columnWidths: this.props.columnWidths,
                leftMargin: this.props.leftMargin,
                measuredColumnWidths: this.props.measuredColumnWidths,
                measureColumnWidths: sectionRowStartIdx === pageIndexes.startRowIdx ? this.props.measureColumnWidths : undefined,
                rows: this.props.rows,
                rowStartIdx: sectionRowStartIdx,
                rowEndIdx: Math.min(sectionRowStartIdx + this.props.sectionRows, this.props.rows.length) - 1,
                onCellClick: this.props.onCellClick,
                onCellDoubleClick: this.props.onCellDoubleClick,
                onCellContextMenu: this.props.onCellContextMenu,
                onRowHeaderCellClick: this.props.onRowHeaderCellClick,
                selectionModel: this.props.selectionModel,
                selectionTimestamp: this.props.selectionTimestamp,
                showRowBanding: this.props.showRowBanding,
                showHorizontalGridLines: this.props.showHorizontalGridLines,
                showVerticalGridLines: this.props.showVerticalGridLines,
                rowOuterHeight: this.props.rowOuterHeight
            }));
        }
        return sections;
    };
    Body.prototype.isScrollTopPosValidForNextProps = function (nextProps) {
        var nextRowCount = nextProps.rows.length;
        var nextRowOuterHeight = nextProps.rowOuterHeight;
        if (nextRowCount === this.props.rows.length && nextRowOuterHeight === this.props.rowOuterHeight) {
            return true;
        }
        return this.scrollTop <= (nextRowCount * nextRowOuterHeight);
    };
    Body.prototype.isScrollTopPosValidForPageIndexes = function (scrollTop, pageIndexes) {
        var firstRowTopPx = pageIndexes.startRowIdx * this.props.rowOuterHeight;
        var lastRowBottomPx = (pageIndexes.endRowIdx + 1) * this.props.rowOuterHeight;
        var rowsInViewPort = Math.floor(this.clientHeight / this.props.rowOuterHeight);
        var rowsCount = this.props.rows.length;
        if (rowsCount > rowsInViewPort && (pageIndexes.endRowIdx + 1) < rowsCount) {
            lastRowBottomPx -= (rowsInViewPort * this.props.rowOuterHeight);
        }
        return scrollTop >= Math.max(firstRowTopPx, 0) && scrollTop <= Math.max(lastRowBottomPx, 0);
    };
    Body.displayName = 'DataGridBody';
    return Body;
}(React.Component));
exports.Body = Body;
(function (Body) {
    ;
})(Body = exports.Body || (exports.Body = {}));
exports.Body = Body;
//# sourceMappingURL=Body.js.map